// extracted by mini-css-extract-plugin
export default {"section":"Oa","isInverse":"Pa","heading":"Qa","isSubtle":"Ra","isImpact":"Sa","lead":"Ta","blinking":"Ua"};